import { Link } from "react-router-dom";

/**
 * Official Swipetronics logo. DO NOT replace with an AI mark.
 * Variants:
 *   - "dark" (default): for light backgrounds — uses original navy + electric blue logo
 *   - "light": for dark navy backgrounds — uses light variant (navy parts converted to white)
 *   - "icon": just the brand mark (S + card swipe), no wordmark
 */
export default function Logo({ variant = "dark", className = "", to = "/", linkClassName = "", testId = "logo-link" }) {
  const src =
    variant === "light"
      ? "/brand/swipetronics-logo-light.png"
      : "/brand/swipetronics-logo.png";

  const content = (
    <img
      src={src}
      alt="Swipetronics"
      className={className}
      draggable={false}
    />
  );

  if (!to) return content;

  return (
    <Link to={to} className={`inline-flex items-center ${linkClassName}`} data-testid={testId} aria-label="Swipetronics — Home">
      {content}
    </Link>
  );
}
